import shaderHelper from "../helpers/shaderHelper";
import * as glslify from 'glslify'
import * as THREE from 'three'

class blueNoise {



    constructor() {

        this.sharedUniforms = {};
        this.resultArray = void 0;
        this.shrink_by = 128;


        // this.init();
    }

    /**
     * @return {undefined}
     */
    init(_options) {
        this.resources = _options.resources
        this.blueNoiseTexture = this.resources.items.blueNoiseTexture
        var texture = this.blueNoiseTexture;
        /** @type {boolean} */
        texture.generateMipmaps = false;
        texture.minFilter = texture.magFilter = THREE.NearestFilter;
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        this.sharedUniforms.u_blueNoiseTexture = {
            value: texture
        };
        this.sharedUniforms.u_blueNoiseTexelSize = {
            value: new THREE.Vector2(1 / this.shrink_by, 1 / this.shrink_by)
        };
        this.sharedUniforms.u_blueNoiseCoordOffset = {
            value: this.resultArray = new THREE.Vector2
        };
        shaderHelper.addChunk("getBlueNoise", glslify(["#define GLSLIFY 1\nuniform sampler2D u_blueNoiseTexture;\nuniform vec2 u_blueNoiseTexelSize;\nuniform vec2 u_blueNoiseCoordOffset;\n\n// getBlueNoise(gl_FragCoord.xy)\nvec3 getBlueNoise (vec2 coord) {\n\treturn texture2D(u_blueNoiseTexture, coord * u_blueNoiseTexelSize + u_blueNoiseCoordOffset).rgb;\n}\n// getStaticBlueNoise(gl_FragCoord.xy)\nvec3 getStaticBlueNoise (vec2 coord) {\n\treturn texture2D(u_blueNoiseTexture, coord * u_blueNoiseTexelSize).rgb;\n}"]));
    };
    /**
     * @param {!Object} val
     * @return {undefined}
     */
    update(val) {
        this.resultArray.set(Math.random(), Math.random());
    };

}

const blueNoiseInstance = new blueNoise();

export default blueNoiseInstance;

